export default {
  groupName: 'ford-us-growth',
  appName: 'Ford US Focus Audience',
  isAuto: true,
  baseRoute: '/ford-us-growth',
  image: 'ford.png',
  description:
    'Ford - US Focus Audience Advertising Dashboard'
}
